import classnames from "classnames";
import React, { useContext } from "react";
import {
  RicosAlignmentContext,
  RicosNodeContextProvider,
  VisibleIndentationContext,
  VisibleIndentationContextProvider
} from "./../../../../../ricos-context";
import { TextStyle_TextAlignment } from "./../../../../../ricos-schema/legacy/wix/rich_content/v1";
import alignmentStyle from "../../../../statics/alignment.rtlignore-scss";
import styles from "./lists-scss";
const BulletedList = ({ node, nodeIndex, RicosNodesRenderer }) => {
  const { textAlignment } = useContext(RicosAlignmentContext);
  const { visibleIndentation } = useContext(VisibleIndentationContext);
  const currIndentation = visibleIndentation?.indentation || 0;
  const currOffset = node.bulletedListData?.offset || 0;
  const indentation = (visibleIndentation && visibleIndentation?.nodeId !== node.id ? 1 : 0) + currIndentation + currOffset;
  const bulletedListClassName = classnames(
    styles.bulletedlist,
    alignmentStyle[textAlignment || TextStyle_TextAlignment.AUTO]
  );
  return /* @__PURE__ */ React.createElement("ul", { className: bulletedListClassName }, /* @__PURE__ */ React.createElement(VisibleIndentationContextProvider, { visibleIndentation: { indentation, nodeId: node.id } }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes ?? [] }))));
};
const BulletedListRenderer = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(BulletedList, { key: node.id, node, ...props });
};
var bulletedList_default = BulletedListRenderer;
export {
  bulletedList_default as default
};
//# sourceMappingURL=bulletedList.js.map
